<template>
  <footer
    class="relative bg-gradient-to-br from-primary-600 via-primary-700 to-primary-800 text-white overflow-hidden"
  >
    <div class="absolute inset-0 opacity-10">
      <div
        class="absolute inset-0"
        style="
          background-image: url('data:image/svg+xml,%3Csvg width=&quot;60&quot; height=&quot;60&quot; viewBox=&quot;0 0 60 60&quot; xmlns=&quot;http://www.w3.org/2000/svg&quot;%3E%3Cg fill=&quot;none&quot; fill-rule=&quot;evenodd&quot;%3E%3Cg fill=&quot;%23ffffff&quot; fill-opacity=&quot;0.1&quot;%3E%3Cpath d=&quot;M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z&quot;/%3E%3C/g%3E%3C/g%3E%3C/svg%3E');
        "
      ></div>
    </div>
    <!-- Scrolling banner with icon -->
    <!-- <div
      class="w-full bg-primary-400 py-2 overflow-hidden border-t border-primary flex"
    >
      <div class="animate-marquee">
        <div
          class="whitespace-nowrap font-semibold text-sm text-white flex items-center"
        >
          <ColorImg
            src="/images/icons/flash.svg"
            class="bg-white/70 w-6 h-6 min-w-6 mr-2"
          />
          <span class="mx-8">FREE FOR A LIMITED TIME</span>
          <ColorImg
            src="/images/icons/flash.svg"
            class="bg-white/70 w-6 h-6 min-w-6 mr-2"
          />
          <span class="mx-8">FREE FOR A LIMITED TIME</span>
          <ColorImg
            src="/images/icons/flash.svg"
            class="bg-white/70 w-6 h-6 min-w-6 mr-2"
          />
          <span class="mx-8">FREE FOR A LIMITED TIME</span>
          <ColorImg
            src="/images/icons/flash.svg"
            class="bg-white/70 w-6 h-6 min-w-6 mr-2"
          />
          <span class="mx-8">FREE FOR A LIMITED TIME</span>
          <ColorImg
            src="/images/icons/flash.svg"
            class="bg-white/70 w-6 h-6 min-w-6 mr-2"
          />
          <span class="mx-8">FREE FOR A LIMITED TIME</span>
          <ColorImg
            src="/images/icons/flash.svg"
            class="bg-white/70 w-6 h-6 min-w-6 mr-2"
          />
          <span class="mx-8">FREE FOR A LIMITED TIME</span>
          <ColorImg
            src="/images/icons/flash.svg"
            class="bg-white/70 w-6 h-6 min-w-6 mr-2"
          />
          <span class="mx-8">FREE FOR A LIMITED TIME</span>
          <ColorImg
            src="/images/icons/flash.svg"
            class="bg-white/70 w-6 h-6 min-w-6 mr-2"
          />
          <span class="mx-8">FREE FOR A LIMITED TIME</span>
          <ColorImg
            src="/images/icons/flash.svg"
            class="bg-white/70 w-6 h-6 min-w-6 mr-2"
          />
          <span class="mx-8">FREE FOR A LIMITED TIME</span>
          <ColorImg
            src="/images/icons/flash.svg"
            class="bg-white/70 w-6 h-6 min-w-6 mr-2"
          />
          <span class="mx-8">FREE FOR A LIMITED TIME</span>
          <ColorImg
            src="/images/icons/flash.svg"
            class="bg-white/70 w-6 h-6 min-w-6 mr-2"
          />
          <span class="mx-8">FREE FOR A LIMITED TIME</span>
          <ColorImg
            src="/images/icons/flash.svg"
            class="bg-white/70 w-6 h-6 min-w-6 mr-2"
          />
          <span class="mx-8">FREE FOR A LIMITED TIME</span>
          <ColorImg
            src="/images/icons/flash.svg"
            class="bg-white/70 w-6 h-6 min-w-6 mr-2"
          />
          <span class="mx-8">FREE FOR A LIMITED TIME</span>
          <ColorImg
            src="/images/icons/flash.svg"
            class="bg-white/70 w-6 h-6 min-w-6 mr-2"
          />
          <span class="mx-8">FREE FOR A LIMITED TIME</span>
          <ColorImg
            src="/images/icons/flash.svg"
            class="bg-white/70 w-6 h-6 min-w-6 mr-2"
          />
          <span class="mx-8">FREE FOR A LIMITED TIME</span>
          <ColorImg
            src="/images/icons/flash.svg"
            class="bg-white/70 w-6 h-6 min-w-6 mr-2"
          />
          <span class="mx-8">FREE FOR A LIMITED TIME</span>
          <ColorImg
            src="/images/icons/flash.svg"
            class="bg-white/70 w-6 h-6 min-w-6 mr-2"
          />
          <span class="mx-8">FREE FOR A LIMITED TIME</span>
          <ColorImg
            src="/images/icons/flash.svg"
            class="bg-white/70 w-6 h-6 min-w-6 mr-2"
          />
          <span class="mx-8">FREE FOR A LIMITED TIME</span>
          <ColorImg
            src="/images/icons/flash.svg"
            class="bg-white/70 w-6 h-6 min-w-6 mr-2"
          />
          <span class="mx-8">FREE FOR A LIMITED TIME</span>
          <ColorImg
            src="/images/icons/flash.svg"
            class="bg-white/70 w-6 h-6 min-w-6 mr-2"
          />
          <span class="mx-8">FREE FOR A LIMITED TIME</span>
        </div>
      </div>
    </div> -->

    <!-- Footer content -->
    <div class="container mx-auto py-12 px-8 relative z-10">
      <div class="grid grid-cols-1 md:grid-cols-4 gap-8 text-sm">
        <!-- Branding -->
        <div class="col-span-full mb-8">
          <ImgComponent
            src="/images/logo_complet.jpg"
            class="h-16 w-auto rounded-lg"
          />
        </div>

        <!-- Accueil -->
        <div>
          <div
            class="font-bold mb-4 flex items-center gap-2 text-primary-200 uppercase tracking-widest text-xs"
          >
            ACCUEIL
          </div>
          <div class="space-y-2">
            <router-link
              to="/"
              class="text-white/80 hover:text-white transition-colors flex items-center gap-2"
            >
              <ColorImg
                src="/images/icons/home.svg"
                class="bg-white/70 w-6 h-6 min-w-6"
              />
              Page d'accueil
            </router-link>
            <router-link
              to="/parcours-employabilite"
              class="text-white/80 hover:text-white transition-colors flex items-center gap-2"
            >
              <ColorImg
                src="/images/icons/graduation-cap.svg"
                class="bg-white/70 w-6 h-6 min-w-6"
              />
              Parcours Employabilité
            </router-link>
            <router-link
              to="/parcours-entrepreneur"
              class="text-white/80 hover:text-white transition-colors flex items-center gap-2"
            >
              <ColorImg
                src="/images/icons/business.svg"
                class="bg-white/70 w-6 h-6 min-w-6"
              />
              Parcours Entrepreneur
            </router-link>
            <router-link
              to="/certifications"
              class="text-white/80 hover:text-white transition-colors flex items-center gap-2"
            >
              <ColorImg
                src="/images/icons/certificate.svg"
                class="bg-white/70 w-6 h-6 min-w-6"
              />
              Nos Certifications
            </router-link>
            <router-link
              to="/orienta"
              class="text-white/80 hover:text-white transition-colors flex items-center gap-2"
            >
              <ColorImg
                src="/images/icons/globe.svg"
                class="bg-white/70 w-6 h-6 min-w-6"
              />
              Orienta Tour
            </router-link>
          </div>
        </div>

        <!-- Certifications -->
        <div>
          <div class="font-bold mb-4 flex items-center gap-2">
            <ColorImg
              src="/images/icons/award.svg"
              class="bg-white/70 w-6 h-6 min-w-6"
            />
            CERTIFICATIONS
          </div>
          <div class="space-y-2">
            <router-link
              to="/certifications/soft-skills-pro"
              class="text-white/80 hover:text-white transition-colors flex items-center gap-2"
            >
              <ColorImg
                src="/images/icons/brain.svg"
                class="bg-white/70 w-6 h-6 min-w-6"
              />
              Soft Skills Pro
            </router-link>
            <router-link
              to="/certifications/disc-10x"
              class="text-white/80 hover:text-white transition-colors flex items-center gap-2"
            >
              <ColorImg
                src="/images/icons/chart-line.svg"
                class="bg-white/70 w-6 h-6 min-w-6"
              />
              10× Productive
            </router-link>
            <router-link
              to="/certifications/orienta-coach"
              class="text-white/80 hover:text-white transition-colors flex items-center gap-2"
            >
              <ColorImg
                src="/images/icons/users.svg"
                class="bg-white/70 w-6 h-6 min-w-6"
              />
              Coach Orienta
            </router-link>
            <router-link
              to="/certifications/formateur-exception"
              class="text-white/80 hover:text-white transition-colors flex items-center gap-2"
            >
              <ColorImg
                src="/images/icons/graduation-cap.svg"
                class="bg-white/70 w-6 h-6 min-w-6"
              />
              Formateurs d'Exception
            </router-link>
          </div>
        </div>

        <!-- Programmes -->
        <div>
          <div class="font-bold mb-4 flex items-center gap-2">
            <ColorImg
              src="/images/icons/target.svg"
              class="bg-white/70 w-6 h-6 min-w-6"
            />
            PROGRAMMES
          </div>
          <div class="space-y-2">
            <div
              class="text-white/80 flex items-center gap-2"
              @click="
                () => {
                  $bus.emit($constants.EVENTS.REGISTRATION?.OPEN, {
                    level: '101'
                  });
                }
              "
            >
              <ColorImg
                src="/images/icons/gift.svg"
                class="bg-white/70 w-6 h-6 min-w-6"
              />
              Employabilité 101
            </div>
            <div
              class="text-white/80 flex items-center gap-2"
              @click="
                () => {
                  $bus.emit($constants.EVENTS.REGISTRATION?.OPEN, {
                    level: '201'
                  });
                }
              "
            >
              <ColorImg
                src="/images/icons/crown.svg"
                class="bg-white/70 w-6 h-6 min-w-6"
              />
              Employabilité 201
            </div>
            <div
              class="text-white/80 flex items-center gap-2"
              @click="
                () => {
                  $bus.emit($constants.EVENTS.REGISTRATION?.OPEN, {
                    level: '301'
                  });
                }
              "
            >
              <ColorImg
                src="/images/icons/diamond.svg"
                class="bg-white/70 w-6 h-6 min-w-6"
              />
              Employabilité 301
            </div>
          </div>
        </div>

        <!-- Contact -->
        <div>
          <div class="font-bold mb-4 flex items-center gap-2">
            <ColorImg
              src="/images/icons/mail.svg"
              class="bg-white/70 w-6 h-6 min-w-6"
            />
            CONTACT
          </div>
          <div class="space-y-2">
            <!-- <div class="text-white/80 flex items-center gap-2">
              <ColorImg
                src="/images/icons/phone.svg"
                class="bg-white/70 w-6 h-6 min-w-6"
              />
              +229 XX XX XX XX XX
            </div> -->
            <div class="text-white/80 flex items-center gap-2">
              <ColorImg
                src="/images/icons/mail.svg"
                class="bg-white/70 w-6 h-6 min-w-6"
              />
              info@parcourspro.fr
            </div>
            <div class="text-white/80 flex items-center gap-2">
              <ColorImg
                src="/images/icons/map-pin.svg"
                class="bg-white/70 w-6 h-6 min-w-6"
              />
              Canada
            </div>
          </div>
        </div>
      </div>

      <!-- Bottom line -->
      <div class="border-t border-primary-400 my-8"></div>
      <div
        class="flex flex-col md:flex-row justify-between items-center text-xs gap-4"
      >
        <div class="text-white/80 flex items-center gap-2">
          <ColorImg
            src="/images/icons/copyright.svg"
            class="bg-white/70 w-6 h-6 min-w-6"
          />
          © Parcours Pro 2025. Tous droits réservés.
        </div>
        <div class="flex gap-6 text-white/80">
          <a
            href="https://linkedin.com"
            target="_blank"
            class="hover:text-white transition-colors"
            title="LinkedIn"
          >
            <ColorImg
              src="/images/icons/linkedin.svg"
              class="bg-white/70 w-6 h-6 min-w-6"
            />
          </a>
          <a
            href="https://facebook.com"
            target="_blank"
            class="hover:text-white transition-colors"
            title="Facebook"
          >
            <ColorImg
              src="/images/icons/facebook.svg"
              class="bg-white/70 w-6 h-6 min-w-6"
            />
          </a>
          <a
            href="https://instagram.com"
            target="_blank"
            class="hover:text-white transition-colors"
            title="Instagram"
          >
            <ColorImg
              src="/images/icons/instagram.svg"
              class="bg-white/70 w-6 h-6 min-w-6"
            />
          </a>
          <a
            href="https://youtube.com"
            target="_blank"
            class="hover:text-white transition-colors"
            title="YouTube"
          >
            <ColorImg
              src="/images/icons/youtube.svg"
              class="bg-white/70 w-6 h-6 min-w-6"
            />
          </a>
          <a
            href="https://x.com"
            target="_blank"
            class="hover:text-white transition-colors"
            title="X/Twitter"
          >
            <ColorImg
              src="/images/icons/x-twitter.svg"
              class="bg-white/70 w-6 h-6 min-w-6"
            />
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<style scoped>
@keyframes marquee {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}
.animate-marquee {
  display: inline-block -mb-1-block;
  min-width: 200%;
  animation: marquee 18s linear infinite;
}
</style>
